import { type FC } from "react";
import { Presentation } from "./Presentation";
import { type ComponentHash } from "./type";
import { useUniformInputs } from "./useUniformInputs";

type Props = {
  componentHash: ComponentHash;
};

export const UniformInputs: FC<Props> = ({ componentHash }) => {
  const uniformInputsProps = useUniformInputs(componentHash);

  return (
    <Presentation
      value={uniformInputsProps.value}
      formNames={uniformInputsProps.formNames}
      inputValues={uniformInputsProps.inputValues}
      text={uniformInputsProps.text}
      checked={uniformInputsProps.checked}
      handleChangeCheckbox={uniformInputsProps.handleChangeCheckbox}
      handleInputChange={uniformInputsProps.handleInputChange}
      parentCheckboxId={uniformInputsProps.parentCheckboxId}
      errors={uniformInputsProps.errors}
    />
  );
};
